export default __webpack_public_path__ + "static/media/TEXTURA_02.60f3f6c1.png";